import { FilterAltOutlined } from '@mui/icons-material';
import { Chip, ChipProps } from '@mui/material';
import { deepmerge } from '@mui/utils';
import { memo } from 'react';
import { FilterStatus, getFilterStatusLabel } from '../enums/FilterStatus';

type Props = ChipProps & {
  filterStatus: FilterStatus;
  format?: 'normal' | 'large';
  noBorder?: boolean;
};

export const FilterStatusBadge = memo(({ filterStatus, noBorder = false, format = 'normal', sx = {}, ...rest }: Props) => {
  if (!filterStatus || filterStatus === FilterStatus.FULLY_KEPT) {
    return null;
  }
  const borderRadius = format === 'normal' ? '8px' : '4px';
  const height = format === 'normal' ? '2rem' : '2.25rem';
  return (
    <Chip
      className="filter-status-chip"
      icon={<FilterAltOutlined />}
      label={getFilterStatusLabel(filterStatus)}
      variant="outlined"
      color="primary"
      sx={deepmerge(sx, { borderRadius, height, ...(noBorder ? { border: 'none', height: 'auto', '& svg': { marginLeft: '0 !important' } } : {}) })}
      {...rest}
    />
  );
});
